import { Fragment } from "react";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { PageNavbar } from "@/pages/account";
import { useLayout } from "@/providers";
import ServiceModerationTab from "./components/ServiceModerationTab";

const ServiceModerationManagement = () => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="service-moderation-management-heading" />
              <ToolbarDescription>
                Moderate and approve/reject service listings.
              </ToolbarDescription>
            </ToolbarHeading>
          </Toolbar>
        </Container>
      )}
      <Container>
        <ServiceModerationTab />
      </Container>
    </Fragment>
  );
};

export { ServiceModerationManagement };
